export const LOCAL_STORAGE_KEYS = {
  authToken: "authToken",
};
